import styled, { css, keyframes } from "styled-components";

import { GRAY_DARK, WHITE } from "../../colors";
import { Caption } from "../../typography";
import positions from "../constants/positions";

const getPositionStyles = ({ position, spacer }) => {
  const positionStyles = {
    [positions.BOTTOM]: css`
      left: 50%;
      transform: translate(-50%, ${spacer}px);

      &::after {
        border-color: transparent transparent ${GRAY_DARK} transparent;
        border-style: solid;
        border-width: 5px;
        content: " ";
        left: 50%;
        position: absolute;
        top: -9px;
        transform: translateX(-50%);
      }
    `,
    [positions.LEFT]: css`
      top: 50%;
      transform: translate(calc(-100% - ${spacer}px), -50%);

      &::after {
        border-color: transparent transparent transparent ${GRAY_DARK};
        border-style: solid;
        border-width: 5px;
        content: " ";
        position: absolute;
        right: -9px;
        top: 50%;
        transform: translateY(-50%);
      }
    `,
    [positions.RIGHT]: css`
      left: calc(100% + ${spacer}px);
      top: 50%;
      transform: translateY(-50%);

      &::after {
        border-color: transparent ${GRAY_DARK} transparent transparent;
        border-style: solid;
        border-width: 5px;
        content: " ";
        left: -4px;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    `,
    [positions.TOP]: css`
      bottom: calc(100% + ${spacer}px);
      left: 50%;
      transform: translateX(-50%);

      &::after {
        border-color: ${GRAY_DARK} transparent transparent transparent;
        border-style: solid;
        border-width: 5px;
        content: " ";
        left: 50%;
        position: absolute;
        top: 100%;
        transform: translateX(-50%);
      }
    `
  };

  return positionStyles[position];
};

const tooltipContentFadeIn = keyframes`
  from {
    opacity: 0
  }
  
  to {
    opacity: 1
  }
`;

const triggerAnimation = ({ isVisible }) =>
  isVisible &&
  css`
    animation: ${tooltipContentFadeIn} 330ms linear;
  `;

export const TooltipContent = styled.div`
  background-color: ${GRAY_DARK};
  border-radius: 3px;
  padding: 8px 16px;
  position: absolute;
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
  white-space: nowrap;
  z-index: ${({ zIndex }) => zIndex};

  ${getPositionStyles};
  ${triggerAnimation};
`;

export const TooltipContainer = styled.div`
  * {
    box-sizing: border-box;
  }

  display: inline-block;
  position: relative;
`;

export const TooltipText = styled(Caption)`
  color: ${WHITE};
`;
